<template>
  <div class="news">
    <header class="curation-header-news" v-if="curation">
      <div class="representative-image" v-if="curation.image">
        <UiImageSelection :image="curation.image" :fullsize="true" />
      </div>
      <BaseSectionContainer
        tag="div"
        size="middle"
      >
        <div class="jps-header-information">
          <h1 class="title">
            <BaseIcon
              name="koicon/koicon-21"
              class="jps-koicon"
              size="size-full"
            />
            <span
              class="jps-header-type-title is-size-5-desktop is-size-6-touch"
              >{{ ldate(page.date) }}</span
            >
            <span
              class="jps-header-object-title is-size-4-desktop is-size-5-touch"
              >{{ ls(page.title) }}</span
            >
          </h1>
          <div class="jps-header-description">
            <p class="is-size-6-desktop is-size-7-touch">
              {{ ls(page.description) }}
            </p>
          </div>
        </div>
      </BaseSectionContainer>
    </header>
    <CurationRenderer class="jps-page" :curation="curation" :page="page" :noheader="true" />
  </div>
</template>

<script lang="ts" setup>
definePageMeta({
  qsearch: true,
  disableDefaultMargin: true,
})

const { getPageAndCache } = usePage()
const { page, meta } = await getPageAndCache()
useHead(meta)

const { ls, ldate } = useI18n()
const dataStore = useDataStore()

const curation = computed(() => {
  if (page) {
    return dataStore.curation(getPageCurationId(page.id))
  }
  return null
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.news {
  padding-top: 3rem;
  padding-bottom: 3rem;
  .curation-header-news {
    @include details-header;
    @include details-header-is-light;

    .representative-image {
      cursor: pointer;
      height: 512px;
      width: 100%;
      text-align: center;
      .jps-image-selection {
        background: $black;
      }
    }
    /* mobileの場合には16:9で固定 */
    @include is-mobile {
      .representative-image {
        height: unset;
        @include ratio16x9Wrapper;
        .jps-image-selection {
          @include ratioInner;
        }
      }
    }

    .jps-image-selection {
      background: none;
    }

    .item-search-result {
      padding-top: 0;
    }

    .jps-header-description,
    .org-container,
    .jps-database-search {
      @include global-width-strict();
    }

    > section {
      @include is-mobile() {
        padding: 1rem 1rem;
      }
      @include is-tablet() {
        padding: 0 2rem;
        margin: 3rem auto;
      }

      h2 {
        font-weight: bold;
        margin-bottom: 0.5rem;
      }
      p.description {
        margin-bottom: 1.5rem;
      }
      .org-container {
        .jps-database-license-and-sample {
          background: $white;
          border-radius: $global-radius;
        }
      }

      .jps-organization {
        dd {
          a {
            display: block;
            line-height: 150%;
          }
        }
      }
      div.level.stat {
        border-bottom: 1px solid $jps-gray-300;
        padding-bottom: 1rem;
      }
      dl.stat,
      dl.jps-org-span {
        overflow: hidden;
        dt,
        dd {
          margin-top: 0.25rem;
        }
        dt {
          float: left;
          clear: both;
        }
        dd {
          padding-top: 0.35rem;
          font-size: 0.875rem;
        }
      }

      .license-purpose-base {
        border-bottom: 3px solid $jps-gray-300;
        h3 {
          margin-bottom: 0.25rem;
        }
      }

      dl.license {
        overflow: hidden;
        @include is-tablet {
          margin: 1.5rem 0 3rem;
        }
        dt,
        dd {
          margin-top: 0.25rem;
          &:first-child {
            margin-top: 0.5rem;
          }
        }
        dt {
          float: left;
          clear: both;
          padding-top: 0.25rem;
          @include is-mobile {
            display: none;
          }
          @include is-tablet {
            margin-bottom: 2rem;
          }
        }
        dd {
          padding-top: 0rem;
          font-size: 0.875rem;
          @include is-tablet {
            margin-left: 4rem;
            margin-bottom: 2rem;
            min-height: 3rem;
          }
          .description {
            color: $jps-gray-600;
            margin-top: 0.5rem;
          }
        }
      }
      div.jps-database-result {
        margin-bottom: 1rem;
        .item-search-result {
          background: none;
          .left-side {
            display: none;
          }
          .tile.is-parent {
            margin: 0;
            padding: 1.75rem 1px;
          }
        }
      }
    }
    .tab-item h3 {
      margin-top: 1rem;
      font-weight: bold;
      .b-tabs .tab-content {
        padding: 2rem;
      }
    }

    .org-container {
      .box {
        padding: 0;
        .b-tabs {
          padding: 1.25rem;
        }
        .jps-db-notification {
          justify-content: left;
          background: $jps-gray-100;
          padding: 1rem;
          @include is-mobile {
            padding: 0.5rem;
          }
          p,
          span {
            color: $jps-key-red;
          }
          p {
            margin-left: 0.75rem;
          }
        }
      }
    }
  }
}
.jps-koicon {
  margin-right: 0.375rem;
  @include is-mobile {
    max-width: 1rem;
    max-height: 1rem;
  }
  @include is-tablet {
    max-width: 1.5rem;
    max-height: 1.5rem;
  }
}
</style>
